import { useState } from "react";

import { Navigation, A11y } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

const StockKeySlider = () => {
  const [isPrevSecDisabled, setIsPrevSecDisabled] = useState(true);
  const [isNextSecDisabled, setIsNextSecDisabled] = useState(false);

  const handleSlideSecChange = (swiper) => {
    setIsPrevSecDisabled(swiper.isBeginning);
    setIsNextSecDisabled(swiper.isEnd);
  };

  return (
    <div>
      <div className="why-custom-swiper">
        <Swiper
          spaceBetween={12}
          slidesPerView={4}
          modules={[Navigation, A11y]}
          navigation={{
            prevEl: ".why-custom-prev-arrow",
            nextEl: ".why-custom-next-arrow",
          }}
          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            480: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            1025: {
              slidesPerView: 4,
              spaceBetween: 40,
            },
          }}
          onSlideChange={handleSlideSecChange}
          onReachBeginning={() => setIsPrevSecDisabled(true)}
          onReachEnd={() => setIsNextSecDisabled(true)}
          onFromEdge={() => {
            setIsPrevSecDisabled(false);
            setIsNextSecDisabled(false);
          }}
        >
          <SwiperSlide>
            <div className="st-challenge-cards st-key-cards">
              <div className="st-challenge-card-inner">
                <div className="st-key-img-wrap">
                  <img
                    src={require("../../../image/stocktrading/key-img-one.webp")}
                    alt="Stock Trading App Development Company"
                  />
                </div>
                <h6>User-Friendly Interface</h6>
                <p>
                  A seamless and intuitive interface is crucial. Stock trading
                  app development should prioritize ease of navigation to
                  attract and retain users.
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="st-challenge-cards st-key-cards">
              <div className="st-challenge-card-inner">
                <div className="st-key-img-wrap">
                  <img
                    src={require("../../../image/stocktrading/key-img-two.webp")}
                    alt="Stock Trading App Development Company"
                  />
                </div>
                <h6>Real-Time Market Updates</h6>
                <p>
                  Live stock prices, market trends, and news updates are
                  essential for informed trading. Stock trading app development
                  integrates these features to keep users updated.
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="st-challenge-cards st-key-cards">
              <div className="st-challenge-card-inner">
                <div className="st-key-img-wrap">
                  <img
                    src={require("../../../image/stocktrading/key-img-three.webp")}
                    alt="Stock Trading App Development Company"
                  />
                </div>
                <h6>Portfolio Management Tools</h6>
                <p>
                  Users should be able to track their investments and manage
                  their portfolios effortlessly. Stock trading app development
                  includes features that allow for easy tracking of gains,
                  losses, and asset allocation.
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="st-challenge-cards st-key-cards">
              <div className="st-challenge-card-inner">
                <div className="st-key-img-wrap">
                  <img
                    src={require("../../../image/stocktrading/key-img-four.webp")}
                    alt="Stock Trading App Development Company"
                  />
                </div>
                <h6>Advanced Analytics</h6>
                <p>
                  Analytics tools such as charts, historical data, and
                  predictive algorithms are integral to stock trading app
                  development, enabling users to make data-driven decisions.
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="st-challenge-cards st-key-cards">
              <div className="st-challenge-card-inner">
                <div className="st-key-img-wrap">
                  <img
                    src={require("../../../image/stocktrading/key-img-five.webp")}
                    alt="Stock Trading App Development Company"
                  />
                </div>
                <h6>Secure Transactions</h6>
                <p>
                  Stock trading app development incorporates secure payment
                  gateways and data encryption to ensure user trust and safety.
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="st-challenge-cards st-key-cards">
              <div className="st-challenge-card-inner">
                <div className="st-key-img-wrap">
                  <img
                    src={require("../../../image/stocktrading/key-img-six.webp")}
                    alt="Stock Trading App Development Company"
                  />
                </div>
                <h6>Multi-Device Compatibility</h6>
                <p>
                  Whether it’s a smartphone, tablet, or desktop, stock trading
                  app development ensures the app functions seamlessly across
                  all devices.
                </p>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>

        <div className="why-custom-btn-wrapper st-key-btn-wrapper">
          <button
            className={`why-custom-prev-arrow st-key-left-btn ${
              isPrevSecDisabled ? "disabled" : ""
            }`}
            style={{
              color: isPrevSecDisabled ? "#8C8D8D" : "#fff",
              cursor: isPrevSecDisabled ? "not-allowed" : "pointer",
              backgroundColor: isPrevSecDisabled ? "#24272899" : "#24272899",
            }}
          >
            <i className="fa-solid fa-arrow-left"></i>
          </button>
          <button
            className={`why-custom-next-arrow st-key-right-btn ${
              isNextSecDisabled ? "disabled" : ""
            }`}
            style={{
              color: isNextSecDisabled ? "#8C8D8D" : "#fff",
              cursor: isNextSecDisabled ? "not-allowed" : "pointer",
              backgroundColor: isNextSecDisabled ? "#24272899" : "#24272899",
            }}
          >
            <i className="fa-solid fa-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default StockKeySlider;
